<script setup lang="ts">
import { watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useManagementStore } from '@/store/management'
import { useMaintenanceStore } from '@/store/maintenance'
import MaintenanceReportBody from '@/components/Maintenances/Body/MaintenanceReportBody.vue'

// Aba "Manutenções" do Módulo Gerencial: reusa o dashboard de relatório de
// manutenções, alimentado pelo MESMO período analisado do módulo.
const management = useManagementStore()
const maintenance = useMaintenanceStore()
const { period } = storeToRefs(management)

function load() {
  if (period.value.length === 2) {
    maintenance.fetchMaintenanceReport(period.value[0].toISOString(), period.value[1].toISOString())
  }
}

watch(period, load, { immediate: true, deep: true })
</script>

<template>
  <div class="bg-white shadow-4">
    <MaintenanceReportBody />
  </div>
</template>
